import React, { Component, createRef } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
//import Lead from "./Lead";
import { isEmpty, map, size } from "lodash";
import Moment from 'react-moment';
import { getInClientList } from "../../store/clients/actions"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Offcanvas, OffcanvasHeader, OffcanvasBody,
  Input,
  Nav,
  NavItem,
  NavLink,
  TabContent, TabPane, FormGroup, Label,
  CardHeader
} from "reactstrap"
import classnames from "classnames"
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import RsAdNew from "components/buttons/Adnew";
import RsLink from "components/buttons/rsLink";

import ClientPageMenu from "./menu/all-client"
import { toast, ToastContainer } from "react-toastify";

import { API_URL } from "helpers/app_url";
import axios from "axios";

import { MultiSelect } from 'primereact/multiselect';
class InClient extends Component {
  constructor(props) {
    super(props)
    this.state = {
    
    }
    this.toggleActivate = this.toggleActivate.bind(this);
   
    this.dt = createRef();
  }
 
  activateToggle(){
      this.setState({ isActivate: !this.state.isActivate });
      
  }
 
  toggleActivate = arg => {
    const client = arg;
    this.setState({
      client: {
        id: client.id,
      },
    });
    this.activateToggle();
  }



  componentDidMount() {
    const { onGetClientLists } = this.props;
    onGetClientLists(localStorage.getItem('userId'));
   
  }

activeClient(value) {
   this.setState({ isLoading: true });
    
    const authUser = localStorage.getItem("authUser");
    const obj = JSON.parse(authUser);
    const token = obj?.resultData?.bearerToken;

    if (!token) return;

    const headers = {
        Authorization: `Bearer ${token}`
    };

    const payload = {
        id: parseInt(value),  
        isActive: true,
        agentId: localStorage.getItem('userId')
        //isLoginActive: value.loginDisabled

    };
    axios.post(`${API_URL}Client/InactiveClient`, payload, { headers })
        .then(response => {
            if (response.status === 200 && response.data.success) {
                this.setState({ isLoading: false });
                this.props.history.push('/clients')
            } else {
                console.warn('Deactivation failed:', response.data);
            }
        })
        .catch(error => {
            console.error('There was an error!', error);
        });
}
 



  render() {
    const { clientLists,  loading, userdetail, isResponsive } = this.props;
    const { client } = this.state;

    

const typeOptions = [
  { label: "Buyer", value: 1 },
  { label: "Seller", value: 2 },
  { label: "Pre-Construction", value: 4 }
];

    return (
      <React.Fragment>
        <ToastContainer autoClose={2000} />
        {this.props.loading && this.props.loading ? (
          <div className="loading">Loading&#8230;</div>
        ) : null}
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Client Dashboard | Realty Space</title>
          </MetaTags>
          <Container fluid className="">
            <Row className="project-header">
              <Col xl="7">
                <Breadcrumbs
                  title={this.props.t("Clients")}
                  breadcrumbItem={this.props.t("Client Dashboard")}
                />
              </Col>
              <Col xl="5">
                <div className="pt-2 float-end mt-2">

                  <div className="">

                    {/* <RsAdNewV2 to="#" onClick={this.toggleAddNew} className="border-right" iconClass="bx bx-plus-medical">Add new</RsAdNewV2>
                    <RsAdNewV2 to="/clients/import-client" className="" iconClass=" bx bx-upload font-size-18">Import clients</RsAdNewV2> */}
                  </div>

                </div>

              </Col>
            </Row>
       
           

        
       




            <Row>
              <Col lg="12">
                <Card className="border-full mt-4">
                  <CardHeader>
                    <div className="row">
                      <div className="col-sm-8">
                        <ClientPageMenu isResponsive={isResponsive} />
                      </div>
                    
                    </div>


                  </CardHeader>
                  <CardBody>

                    <h5 className="card-title">In-active Clients</h5>

                    <div className="row">

                      <div className="col-sm-4"></div>

                      <div className="col-sm-4 mb20">


                      </div>


                    </div>
                    <div className="clearfix"></div>

                       {isResponsive ? (
                          <DataTable
                        className=""
                        ref={this.dt}
                        value={clientLists}
                        paginator
                        rows={10}
                        rowsPerPageOptions={[10, 20, 30, 50, 100, 150, 200, 500]}
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                        paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        globalFilter={this.state.tableFilter}
                        responsiveLayout="stack"
                        expandedRows={this.state.expandedRows}
                        onRowToggle={(e) => this.setState({ expandedRows: e.data })}

                        rowExpansionTemplate={(rowData) => (
                          <table className="table table-bordered mb-0">
                            <tbody>
                              <tr>
                                <th>Email</th>
                                <td>{rowData.prefferedEmail || "N/A"}</td>
                              </tr>
                              <tr>
                                <th>Phone</th>
                                <td>{rowData.primaryContact?.cContact?.mobile || "N/A"}</td>
                              </tr>
                              <tr>
                                <th>Type</th>
                                <td>
                                  {rowData.clientTypes?.length
                                    ? rowData.clientTypes.map(ct => ct.clientTypeTitle).join(", ")
                                    : "N/A"}
                                </td>
                              </tr>
                              <tr>
                                <th>Status</th>
                                <td>{rowData.isActive ? "Active" : "Inactive"}</td>
                              </tr>
                              <tr>
                                <th>Last Login</th>
                                <td>{rowData.lastLogin ? <Moment format="DD MMM YYYY">{rowData.lastLogin}</Moment> : "-"}</td>
                              </tr>
                            </tbody>
                          </table>
                        )}
                      >


                        <Column expander style={{ width: "3em" }} />
                        <Column
                          header="#"
                          body={(rowData, options) => options.rowIndex + 1}
                          style={{ width: '60px' }}
                        />

                        <Column
                          header="Name"
                          body={(rowData) => (
                            <>
                              {rowData.firstName} {rowData.lastName}
                           </>
                          )}
                        />
                        {/* <Column
    header="Date"
    body={(rowData) => <Moment format="DD MMM YYYY">{rowData.createdDate}</Moment>}
  /> */}
                        <Column
                    headerClassName=""
                    bodyClassName=""
                    
                    body={(rowData) => (
                      <>
                        <RsLink
                          className="btn btn-action btn-sm"
                          iconClass=""
                          onClick={()=> this.toggleActivate(rowData)}
                          //to={"/clients/dashbord/" + rowData.id + '/' + rowData.clientId}
                        >
                          Activate client
                        </RsLink>
                       
                        {/* <RsLink className="btn btn-sm" iconClass="" to="#">
                          Send login email
                        </RsLink> */}
                      </>
                    )}
                  />


                      </DataTable>
                       ):(
                    <DataTable className="" ref={this.dt} stripedRows value={clientLists} paginator rows={10} rowsPerPageOptions={[10, 20, 30, 50, 100, 150, 200, 500]} currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries " paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" globalFilter={this.state.tableFilter} tableStyle={{ minWidth: '50rem' }}   >
                       <Column
                          header="#"
                          headerClassName="header-bg-table"
                          body={(rowData, options) => options.rowIndex + 1}
                          style={{ width: '60px' }}
                        />
                      <Column headerClassName="header-bg-table" field="createdDate	" header="Date" body={(rowData) => {
                        return <Moment format="DD MMM YYYY">{rowData.createdDate}</Moment>;
                      }}></Column>
                      <Column headerClassName="align-middle header-bg-table" bodyClassName="table-data" field="firstName" header="Name"
                        filter
                        showFilterMatchModes={false}  
                        showFilterOperator={false}     
                        showAddButton={false}       
                        showClearButton={false}  
                        body={(rowData) => {
                          return rowData.firstName + " " + rowData.lastName;
                        }}
                      ></Column>

                      <Column
                        headerClassName="header-bg-table"
                        field="primaryContact.cContact.phone"
                        header="Phone"
                         filter
                        showFilterMatchModes={false}  
                        showFilterOperator={false}     
                        showAddButton={false}       
                        showClearButton={false}
                        filterFunction={(value, filter) => {
                            if (!filter) return true;
                            const phone = value.primaryContact?.cContact?.mobile || "";
                            const email = value.prefferedEmail || "";
                            const search = filter.toLowerCase();
                            return phone.toLowerCase().includes(search) || email.toLowerCase().includes(search);
                          }}  
                        body={(rowData) => (
                          <>
                            {rowData.prefferedEmail}
                            <br />
                            {rowData.primaryContact.cContact.mobile}
                          </>
                        )}
                      />
                      <Column
                              headerClassName="align-middle header-bg-table"
                              bodyClassName="table-data"
                              header="Type"
                              filter
                              showFilterMatchModes={false}
                              showFilterOperator={false}
                              showAddButton={false}
                              showClearButton={false}
                              filterMatchMode="in" 
                              field="clientTypes" 
                            filterFunction={(rowData, filter) => {
                              if (!filter || filter.length === 0) return true;

                              // Ensure rowData.clientTypes is an array
                              const typeCodes = Array.isArray(rowData.clientTypes)
                                ? rowData.clientTypes.map(ct => ct.clientTypeCode)
                                : [];

                              // filter can be a single number or array
                              const filterValues = Array.isArray(filter) ? filter : [filter];

                              // return true if any client type matches selected filter(s)
                              return typeCodes.some(code => filterValues.includes(code));
                            }}
                            filterElement={(options) => (
                              <MultiSelect
                                value={options.value || []} // always an array
                                options={typeOptions}
                                onChange={(e) => options.filterApplyCallback(e.value)}
                                placeholder="Select Type"
                                display="chip"
                                className="p-column-filter"
                              />
                            )}
                              body={(rowData) =>
                                rowData.clientTypes?.length ? (
                                  <>
                                    {rowData.clientTypes.map((ct, index) => (
                                      <span key={index}>
                                        {ct.clientTypeTitle}
                                        {index < rowData.clientTypes.length - 1 && <br />}
                                      </span>
                                    ))}
                                  </>
                                ) : (
                                  "N/A"
                                )
                              }
                            />

                      <Column
                        headerClassName="header-bg-table"
                        field="isActive"
                        header="Status"
                        body={(rowData) => (rowData.isActive ? "Active" : "Inactive")}
                      />
                      <Column
                        headerClassName="header-bg-table"
                        field=""
                        header="Last Login"
                        body={(rowData) => (
                          rowData.lastLogin ? (
                            <Moment format="DD MMM YYYY">{rowData.lastLogin}</Moment>
                          ) : '-'
                        )}
                      />
                     <Column
                    headerClassName="header-bg-table action-header"
                    bodyClassName="table-data"
                     header={
                    <div className="justify-content-end">
                      <RsLink
                        onClick={() => this.dt.current.reset()}
                        iconClass="bx bx-reset"
                        className="btn-light"
                      >
                         Reset all filters
                      </RsLink>
                    </div>
                  }
                    body={(rowData) => (
                      <>
                        <RsLink
                          className="btn btn-action btn-sm"
                          iconClass=""
                          onClick={()=> this.toggleActivate(rowData)}
                          //to={"/clients/dashbord/" + rowData.id + '/' + rowData.clientId}
                        >
                          Activate client account
                        </RsLink>
                       
                        {/* <RsLink className="btn btn-sm" iconClass="" to="#">
                          Send login email
                        </RsLink> */}
                      </>
                    )}
                  />
                    </DataTable>
                       )}
                  </CardBody>
                </Card>

              </Col>
            </Row>
          </Container>
        </div>
       
          
       
        <Offcanvas
          isOpen={this.state.isActivate}
          direction="end"
          toggle={this.toggleActivate}
          style={{ width: 800 }}
        >
          <OffcanvasHeader toggle={this.toggleActivate}>
            Activate / De-activate
          </OffcanvasHeader>
          <OffcanvasBody>
                 <p className="font-size-16">There are 2 options to manage client accounts. You may choose one or both options depending on your needs.</p>    
                                                <p className="font-size-16">Neither action deletes any data — all client records, notes, and history remain safely stored and can be restored at any time.</p>
                                                <h3 className="font-size-18"><strong>De-Activate Client </strong></h3>
                                                <p className="font-size-16">Use this if you no longer want to actively work with a client. Their status will change to inactive in your records, but you can re-activate them whenever needed.</p>
                                                <h3 className="font-size-18"><strong>Disable Client Portal Access</strong></h3>
                                                <p className="font-size-16">Use this if you want to stop a client from logging into their portal.</p>
                
                                                    <Row>
                                                        <Col sm={{ size: 3, offset: 3 }}>
                                                         <RsLink 
                                                            iconClass="bx bx bx-user-x"
                                                            className="btn-google btn-block float-end"
                                                            onClick={() => this.activeClient(client?.id) }
                                                            isLoading={this.state.isLoading}
                                                        >
                                                        {this.state.isLoading ? 'Please wait...' : 'Activate Client'}
                                                        </RsLink> 
                                                        </Col>
                                                       
                                                    </Row>    
           

          </OffcanvasBody>
        </Offcanvas>
      </React.Fragment>
    )
  }
}
InClient.propTypes = {
  t: PropTypes.any,
  history:PropTypes.object,
  onGetClientLists: PropTypes.func,
  clientLists: PropTypes.array,
  loading: PropTypes.object,
  userdetail:PropTypes.object,
  isResponsive:PropTypes.object

}
const mapStateToProps = ({ Clients }) => (
  {
    clientLists: Clients.clientLists,
    loading: Clients.loading

  })
const mapDispatchToProps = dispatch => ({
  onGetClientLists: agentID => dispatch(getInClientList(agentID)),

});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(InClient))
